import { createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { API, SCOPE_SUBMITTED_FORMS } from '../../constants'
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common'
import {
  extendListBuilder,
  generateListActions,
} from '../helpers/listActionsHelpers'
import { application } from '../../services/application'
import { ANY_OF_THOSE, CONTAINS, IS_BETWEEN } from '../../constants/filter'

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['createdAt', 'desc'],
  submittedFormDetail: null,
  submittedFormReplies: [],
  repliesPending: false,
  filters: {
    ...INITIAL_LIST_STATE_EXTENDED.filters,
    fields: {
      ...INITIAL_LIST_STATE_EXTENDED.filters.fields,
      adminStatus: {
        type: ANY_OF_THOSE,
        value: ['new', 'pending', 'closed', 'qualified', 'disqualified'],
      },
      organizationName: {
        type: CONTAINS,
        value: '',
      },
      formName: {
        type: CONTAINS,
        value: ''
      },
      updatedAt: {
        type: IS_BETWEEN,
        value: {
          from: null,
          to: null,
        },
      },
    },
  },
  params: {
    onlySubcontractorForms: false,
  },
}

//Actions
const listActions = generateListActions({
  scope: SCOPE_SUBMITTED_FORMS,
  apiMethod: {
    GET_LIST: API.SUBMITTED_FORMS.GET_LIST,
  },
  getStore: store => store.submittedForms,
})

const getReplies = createAsyncThunk(
  'submittedForms/getReplies',
  params => {
    return application.call(API.SUBMITTED_FORMS.GET_REPLIES, params)
  }
)
function onGetReplies(state, action) {
  Object.assign(state, {
    submittedFormReplies: action.payload.data.replies || [],
    repliesPending: false,
  })
}
function onGetRepliesPending(state) {
  Object.assign(state, {
    repliesPending: true,
  })
}

const createReply = createAsyncThunk(
  'submittedForms/createReply',
  params => {
    return application.call(API.SUBMITTED_FORMS.CREATE_REPLY, params)
  }
)
function onCreateReply(state, action) {
  const newReply = action.payload.organizationFormReply
  if (newReply) {
    const updatedReplies = [...state.submittedFormReplies, newReply]
    Object.assign(state, {
      submittedFormReplies: updatedReplies,
    })
  }
}

const assignUser = createAsyncThunk('submittedForms/assignUser', params => {
  return application.call(API.SUBMITTED_FORMS.ASSIGN_USER, params)
})

const getStaffUsers = createAsyncThunk('submittedForms/getStaffUsers', () => {
  return application.call(API.SUBMITTED_FORMS.GET_STAFF_USERS)
})
function onGetStaffUsers(state, action) {
  Object.assign(state, {
    users: action.payload,
  })
}

const downloadFormPdf = createAsyncThunk('submittedForms/downloadFormPdf', params => {
  return application.call(API.SUBMITTED_FORMS.DOWNLOAD_FORM_PDF, params)
})

const assignFormToStaff = createAsyncThunk('submittedForms/assignFormToStaff', params => {
  return application.call(API.SUBMITTED_FORMS.ASSIGN_FORM_TO_STAFF, params)
})

const updateFormAdminStatus = createAsyncThunk('submittedForms/updateFormAdminStatus', params => {
  return application.call(API.SUBMITTED_FORMS.UPDATE_ADMIN_STATUS, params)
})

export const actions = {
  ...listActions,
  getReplies,
  createReply,
  assignUser,
  getStaffUsers,
  downloadFormPdf,
  assignFormToStaff,
  updateFormAdminStatus,
}

export default createReducer(INITIAL_STATE, builder => {
  return extendListBuilder(builder, actions)
    .addCase(getReplies.pending, onGetRepliesPending)
    .addCase(getReplies.fulfilled, onGetReplies)
    .addCase(createReply.fulfilled, onCreateReply)
    .addCase(getStaffUsers.fulfilled, onGetStaffUsers)
})